import FormInputTypes from '../components/atoms/formEnums/formInputTypes';


export default {
  title: 'Credentials',
  attributeName: 'key',
  fields: [
    {
      attributeName: 'api_key',
      label: 'Api Key',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '12rem',
      helpText: 'Api Key',
      canOrder: true,
      canFilter: true,
      canEdit: false,
    },
    {
      attributeName: 'api_secret',
      label: 'Api Secret',
      type: FormInputTypes.TEXT_INPUT.PASSWORD,
      width: '20rem',
      helpText: 'Api Secret',
      canOrder: false,
      canFilter: false,
      canEdit: false,
    },
     {
      attributeName: 'expirationEpoch',
      label: 'Expiration Time',
      helpText: 'Date of the expiration',
      type: FormInputTypes.DATE_TIME,
      sendAlwaysAtCreate: true,
      canEdit: true,
    },
    {
      attributeName: 'isValid',
      label: 'Is Valid',
      type: FormInputTypes.CHECKBOX,
      width: '6rem',
      helpText: 'Indicates if is valid',
      canOrder: true,
      canFilter: true,
      canEdit: true,
      
    },
  ],
};
